<template>
<!-- 我要咨询页面（政策、第三方服务） -->
        <div class="policyApplyView">
            <el-form   label-width="140px" :model="ruleForm" :rules="rules" ref="ruleForm" class="ruleForm">
                <!-- 名称 不需要搜索-直接上一页传过来 prop="policyName" 仅展示-不可编辑-->
                <el-form-item :label="detailType==1?'政策名称':detailType==4?'服务名称':''" class="fileProp">
                    <p>{{ruleForm.policyName}}</p>
                </el-form-item>
                <!-- 需求描述 -->
                <el-form-item label="描述" prop="content" class="fileProp">
                    <el-input placeholder="请输入详细描述" v-model="ruleForm.content" :rows="6" :maxlength="300" :show-word-limit="true" type="textarea"> </el-input>
                </el-form-item>
                <!-- 上传文件 必传-->
                 <el-form-item label="上传图片(选填)"  >
                    <el-upload
                        class="upload-demo"
                        :action='imgActions'
                        name="file"
                        :on-preview="handlePreview"
                        :on-remove="handleRemove"
                        :file-list="fileList"
                        list-type="picture"
                        :before-remove="beforeRemove"
                        :on-success='handleAvatarSuccess'
                        :on-error='handleAvatarError'
                        multiple
                        :limit="3"
                        :on-exceed="handleExceed"
                        >
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">支持.jpg .png格式，大小不超过5M</div>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible">
                        <img width="100%" :src="dialogImageUrl" alt="">
                    </el-dialog>
                </el-form-item> 
                <el-form-item label="">
                    <el-button @click="submitForm('ruleForm')" type="primary" >立即咨询</el-button>
                    <el-button @click="cancle" >&nbsp;&nbsp;取消&nbsp;&nbsp;</el-button>
                </el-form-item>
            </el-form>
        </div>
</template>

<script>
    export default {
        name: "lp-policy-consult",
         data() {
                //  手机验证
                const  valiPhone = (rule, value, callback) => {
                    if (!/^[0-9][0-9]\d{9}$/.test(value)) {
                        callback(new Error('请输入正确的手机号'));
                    } else {
                        callback();
                    }
                }; 
                const { query:{type,title},params:{code:id} }=this.$route;

                return {
                    // 图片上传
                    dialogImageUrl: '',
                    imgActions:`${process.env.baseURL}/file/upload`,
                    dialogVisible: false,
                    //type=1政策，type=4服务
                    detailType:parseInt(type),
                    //文件列表
                    fileList: [],
                    ruleForm:{
                        type:'',//需求类型
                        policyName:'',//名称
                        content:'',//描述
                    },
                    rules: { 
                        policyName: [
                            { required: true, message: '请输入名称', trigger: 'blur' }
                        ],
                        content: [
                            { required: true, message: '请输入描述', trigger: 'blur' }
                        ]
                    },

                };
        },
         mounted() {
             //初始化ruleForm数据
            this.ruleForm=this.initForm();
            
            // 类型设置-此页面仅是咨询页面
            // const { query:{type,title},params:{code:id} }=this.$route;
            // this.detailType=parseInt(type)
        },
        methods: {
            /*文件上传开始*/
            // 上传失败
            handleAvatarError(){
                 this.$message.warning(`上传失败`);
            },
            // 上传成功 
            handleAvatarSuccess(res, file) {

                const {data,code:datacode,msg}=res
                if(datacode==1){
                   
                    let imgdata={
                        name:data.originName,
                        url:data.url,
                        fileSize:data.fileSize
                    }
                    this.fileList.push(imgdata)

                }else{
                    this.$message.warning(msg);
                }
            },
            // 移除文件
            handleRemove(file, fileList) {

                this.fileList=fileList
            },
            // 点击文件列表中已上传的文件
            handlePreview(file) {

                 if(file.url!==null){
                    window.open(file.url)
                }
            },
            // 文件超出个数限制
            handleExceed(files, fileList) {
                // 服务或政策咨询-图片限制3张
                this.$message.warning(`当前限制选择 3 个文件`);
                // this.$message.warning(`当前限制选择 10 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            },
            // 移除文件-提示
            beforeRemove(file, fileList) {
                return this.$confirm(`确定移除 ${ file.name }？`);
            },
           
            /*文件上传结束*/
            //初始化数据
            initForm(){
                const { query:{type,title},params:{code:id} }=this.$route;
                return {
                        type:'',//需求类型
                        policyName:title,//名称
                        content:'',//描述
                        contactPerson:'',//联系人
                        contactPhone:'',//联系电话
                }
            },
            //立即提交
            submitForm(formName) {
                // id=1政策 4第三方服务 
                const { query:{type,title},params:{code:id} }=this.$route;

                const {ruleForm,mechanismId,typeList}=this;
                 // 验证表单-服务目前只有-申请
                this.$refs[formName].validate(async (valid) => {
                if (valid) {
                     /*咨询*/
                     var imagesArr=this.fileList.map((item)=>{ return item.url});
                        var params={
                            companyId:localStorage.getItem('companyId'),//企业id
                            policyId:type==1?id:null,//详情-政策id
                            thirdServerId:type==4?id:null,//详情-服务id
                            image:imagesArr.join(','),//图片
                            remark:ruleForm.content,//描述
                            serverOrderType:2, // 服务订单类型:1申请  2咨询  3预审
                            serverOrderSource:type==1?1:type==4?2:null,//服务订单来源:1政策  2第三方服务  3服务(机构)  4其它
                            name:ruleForm.policyName,//名称
                            parkId:this.$store.state.parkId,//园区
                        }
                        const res= await this.$Apis.getPolicyTermsList(params);
                        const { code,data,msg }=res;
                        if(code==1){
                            this.$message.success('提交成功，请到企业管理中心查看申请进度');
                            this.$router.go(-1);
                        }
                } else {
                    // 验证失败
                    console.log('error submit!!');
                    return false;
                }
                });    
            },
           
            // 取消-返回上一页
            cancle() {
                window.history.go(-1);
            }
        }
    }
</script>


<style lang="less" scoped>
.policyApplyView{
        background-color: #fff;
        width: 100%;
        padding: 50px 38px 28px 38px;
        box-sizing: border-box;
        flex-grow: 1;
        .ruleForm{
            // /deep/ .el-form-item__label:before {
            //     display: none;
            // }
            .el-input,
            .el-select,
            .el-date-editor{
                width: 200px;
                height: 36px;
                line-height: 36px;
                /deep/ .el-input__inner{
                    height: 36px;
                    line-height: 36px;
                }
                /deep/ .el-input-group__append {
                    height: 34px;
                    line-height: 34px;
                    box-sizing: border-box;
                }
            }
            .el-textarea,.upload-demo{
                width: 500px;
            } 
        }
         // 指定模块添加星号
        .el-form{
            // 星号都不要，选填加括号
            /deep/ .fileProp{
                    .el-form-item__label::before{
                        content: ''!important; 
                    }
                }
            // /deep/ .fileProp{
            //         .el-form-item__label::before{
            //             content: '*';
            //             color: #F56C6C;
            //             margin-right: 4px;
            //         }
            //     }
        }
             // 图片上传
            .imgList{
                display: flex;
                flex-wrap: wrap;
                img{
                    width: 148px;
                    height: 148px;
                    margin-right: 20px;
                    border: 1px dashed #d9d9d9;
                    box-sizing: border-box;
                }
            }
    }

</style>


// WEBPACK FOOTER //
// src/components/policyconsulting/index.vue